export default [
  {
    path: '/item-sets',
    component: () => import('./views/Index'),
    name: 'item-sets',
    redirect: { name: 'item-sets-list' },
    children: [
      {
        path: 'list',
        name: 'item-sets-list',
        component: () => import('./views/List'),
        meta: {
          resource: 'content',
        },
      },
      {
        path: 'item-sets/:set_id',
        name: 'item-set-detail',
        component: () => import('./views/Detail'),
        meta: {
          resource: 'content',
        },
      },
    ],
  },
]
